export default __webpack_public_path__ + "static/escola-de-presente-669cd2884d8f02d443e68176595cadfb.png";